<template>
  <div :class="[isOpen ? 'is-open' : '', $mq === 'sm' ? 'panel-side-sm' : 'panel-side']">
    <div class="panel">
      <div class="help">
        <ul>
          <li @click="selectParagraph('istruzioni')">
            <span :class="{'selected' : active === 'istruzioni'}">Istruzioni</span>
            <div class="menu-icon">
              <vue-material-icon v-if="active === 'istruzioni'" name="remove_circle_outline" :size="24"/>
              <vue-material-icon v-else name="add_circle" :size="24"/>
            </div>
          </li>
          <li @click="selectParagraph('progetto')">
            <span :class="{'selected' : active === 'progetto'}">Il Progetto</span>
            <div class="menu-icon">
              <vue-material-icon v-if="active === 'progetto'" name="remove_circle_outline" :size="24"/>
              <vue-material-icon v-else name="add_circle" :size="24"/>
            </div>
          </li>
          <li @click="selectParagraph('archivio')">
            <span :class="{'selected' : active === 'archivio'}">Archivio Cinescatti</span>
            <div class="menu-icon">
              <vue-material-icon v-if="active === 'archivio'" name="remove_circle_outline" :size="24"/>
              <vue-material-icon v-else name="add_circle" :size="24"/>
            </div>
          </li>
          <li @click="selectParagraph('contatti')">
            <span :class="{'selected' : active === 'contatti'}">Contatti</span>
            <div class="menu-icon">
              <vue-material-icon v-if="active === 'contatti'" name="remove_circle_outline" :size="24"/>
              <vue-material-icon v-else name="add_circle" :size="24"/>
            </div>
          </li>
        </ul>
      </div>
      <div class="help" v-show="active === 'istruzioni'">
        <h3>Istruzioni</h3>
        <p class="progetto">
          La <strong>Memoria Visibile</strong> ti permette di scoprire come sono cambiati territori e comunità attraverso la visione di
          filmati che li ritraggono in diversi periodi del Novecento.<br>
          <strong>Naviga nella mappa selezionando gli anni nel menù ed esplora i filmati seguendo i percorsi tematici.</strong><br>
          <br>
          • Una clip può mostrare contemporaneamente più luoghi limitrofi, in questo caso il marker prende come
          riferimento il luogo più significativo.<br>
          <br>
          • La geolocalizzazione è stata effettuata seguendo le indicazioni degli autori dei filmati.
        </p>
      </div>
      <div class="help" v-show="active === 'progetto'">
        <h3>La Memoria Visibile</h3>
        <p class="progetto">
          La <strong>Memoria Visibile</strong> nasce per <strong>mostrare e condividere il patrimonio filmico di Cinescatti</strong>:
          archivio impegnato nel recupero, nella salvaguardia e nella valorizzazione di <strong>film amatoriali e di famiglia</strong>
          realizzati durante il Novecento.<br>
          <br>
          La mappa, <strong>grazie alla geolocalizzazione</strong>, permette di riscoprire la storia di un territorio attraverso lo
          sguardo di chi ne è stato diretto testimone: girando filmati amatoriali.<br>
          <br>
          È visibile una selezione delle raccolte che l’archivio ha effettuato in città e province della Lombardia: <strong>immagini private provenienti da
          archivi famigliari nei formati 16mm, 9,5 Pathé Baby, 8mm e Super8</strong>, un patrimonio inestimabile fatto di
          microstorie; una memoria dal basso che torna a rivivere trasformandosi in narrazione identitaria aperta alla
          comunità.<br>
          <br>
          <br>
          Un progetto di<br>
          <br>
          <img src="@/assets/cinescatti_lab80_logo.png" style="width: 255px;">
          <br>
          <br>
          <br>
          Con il contributo di<br>
          <br>
          <img src="@/assets/reglombardia_logo.png" style="width: 230px;"><br>
        </p>
      </div>
      <div class="help" v-show="active === 'archivio'">
        <h3>Archivio Cinescatti</h3>
        <p>
          <strong>Cinescatti</strong> è un archivio regionale impegnato <strong>nel recupero, nella salvaguardia e nella valorizzazione di film
          amatoriali e di famiglia.</strong> Nato a Bergamo nel 2010 da un progetto di <strong>Lab 80 film</strong>, ha catalogato ad oggi oltre
          quattromila filmati in pellicola in formato 16mm, 9,5 Pathé Baby, 8mm e Super8.
        </p>
      </div>
      <div class="help" v-show="active === 'contatti'">
        <h3>Contatti</h3>
        <p>
          <strong>Archivio Cinescatti</strong> di Lab 80 film<br>
          presso Lab 80 <br>
          via del Lazzaretto 20,<br>
          24124 Bergamo<br>
          tel. 035 342239<br>
          <a href="mailto:cinescatti@lab80.it" target="_blank">cinescatti@lab80.it</a><br>
          <a href="http://www.cinescatti.it/" target="_blank">www.cinescatti.it</a><br>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PanelHelp",
    props: {
      isOpen: {
        type: Boolean,
        default: true
      },
    },
    methods: {
      selectParagraph(paragraph) {
        this.active = paragraph
      }
    },
    data() {
      return {
        active: '',

      }
    },
  }
</script>

<style lang="scss" scoped>

  @import "../styles/variables";

  .help {
    width: 400px;

    strong {
      font-weight: 400;
    }

    h3 {
      color: $red;
      font-weight: bold;
      margin-bottom: 0px!important;
    }

    img {
      width: 100%;
    }

    p {
      margin-top: 10px!important;
      font-weight: 300;
      line-height: 1.3;
      color: $gray;
    }
  }

  @media (max-width: 490px) {
    .help {
      width: 100%;

      .progetto {
        padding-bottom: 190px;
      }
    }
  }

</style>
